import { useThemeName } from "@blox/design-system";

export function useIsDarkMode() {
  return useThemeName() === "dark";
}
